import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeOpacity } from '../app/sliderSlice';

const LensSlider = props => {
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);
    const dispatch = useDispatch();

    const handleChange = event => {
        let opacity = event.target.value / 100;

        let inputRange = document.getElementsByClassName('lens-slider');

        dispatch(changeOpacity(opacity));

        for (let i = 0; i < inputRange.length; i++) {
            if (event.target.value < 10) {
                inputRange[i].classList.add('opacity1');
            }
            if (event.target.value > 10 && event.target.value < 20) {
                inputRange[i].classList.add('opacity2');
            }
            if (event.target.value > 20 && event.target.value < 30) {
                inputRange[i].classList.add('opacity3');
            }
            if (event.target.value > 30 && event.target.value < 40) {
                inputRange[i].classList.add('opacity4');
            }
            if (event.target.value > 40 && event.target.value < 50) {
                inputRange[i].classList.add('opacity5');
            }
            if (event.target.value > 50 && event.target.value < 60) {
                inputRange[i].classList.add('opacity6');
            }
            if (event.target.value > 60 && event.target.value < 70) {
                inputRange[i].classList.add('opacity7');
            }
            if (event.target.value > 70 && event.target.value < 80) {
                inputRange[i].classList.add('opacity8');
            }
            if (event.target.value > 80 && event.target.value < 90) {
                inputRange[i].classList.add('opacity9');
            }
            if (event.target.value > 90) {
                inputRange[i].classList.add('opacity10');
            }

            if (event.target.value < 10) {
                inputRange[i].classList.remove('opacity2');
            }
            if (event.target.value < 20) {
                inputRange[i].classList.remove('opacity3');
            }
            if (event.target.value < 30) {
                inputRange[i].classList.remove('opacity4');
            }
            if (event.target.value < 40) {
                inputRange[i].classList.remove('opacity5');
            }
            if (event.target.value < 50) {
                inputRange[i].classList.remove('opacity6');
            }
            if (event.target.value < 60) {
                inputRange[i].classList.remove('opacity7');
            }
            if (event.target.value < 70) {
                inputRange[i].classList.remove('opacity8');
            }
            if (event.target.value < 80) {
                inputRange[i].classList.remove('opacity9');
            }
            if (event.target.value < 90) {
                inputRange[i].classList.remove('opacity10');
            }
        }
    };

    const handleTabFocus = useCallback(event => {
        const colorButtonElement = document.querySelector('.color-button');

        if (event.key === 'Shift' && event.key === 'Tab') {
            return;
        } else if (event.key === 'Tab') {
            setTimeout(() => colorButtonElement?.focus(), 0);
        }
        return;
    }, []);

    return (
        <>
            <div className="range-container">
                <span className="span-font">INDOOR</span>
                <input
                    aria-label="Lens color slider"
                    className="lens-slider range opacity10"
                    type="range"
                    min="0"
                    max="100"
                    defaultValue="100"
                    step="1"
                    onChange={e => handleChange(e)}
                    tabIndex={isLearnMoreModalOpen ? '-1' : '0'}
                    onKeyDown={handleTabFocus}
                />
                <span className="span-font span-font-bold">OUTDOOR</span>
            </div>
        </>
    );
};
export default LensSlider;
